// extracted by mini-css-extract-plugin
export default {"signUpForm":"LZev2gkuC_ET9DahNxLi"};